import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AvisoLegal from "../pages/legal/AvisoLegal";
import PoliticaPrivacidad from "../pages/legal/PoliticaPrivacidad";
import PoliticaCookies from "../pages/legal/PoliticaCookies";
import JuanluCard from "../pages/juanlu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/juanlu",
    element: <JuanluCard />,
  },
  {
    path: "/aviso-legal",
    element: <AvisoLegal />,
  },
  {
    path: "/politica-de-privacidad",
    element: <PoliticaPrivacidad />,
  },
  {
    path: "/politica-de-cookies",
    element: <PoliticaCookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
